export default __webpack_public_path__ + "static/6910-ccc55a8f2def829045a3fb3b3fdb1f07.jpg";